import { bootstrapAccessForNavigation, routeCapabilityAllowed } from './access-guard'

export const ACCESS_RECOVERY_PATH = '/access-unavailable'

export function safeReturnPath (path) {
  return typeof path === 'string' && path.charAt(0) === '/' &&
    path.charAt(1) !== '/' && path.indexOf('\\') === -1 &&
    !/^\/(login|access-unavailable)([/?#]|$)/.test(path)
    ? path : '/home'
}

export function accessRecoveryLocation (path) {
  return { path: ACCESS_RECOVERY_PATH, query: { redirect: safeReturnPath(path) }, replace: true }
}

// Keep the static recovery route reachable without dynamic routes or another
// permission request. No business route is entered on bootstrap failure.
export function createAuthenticatedNavigation (store, router, tokenReader) {
  return async (to, from, next) => {
    if (to.path === ACCESS_RECOVERY_PATH) {
      next()
      return
    }
    if (!tokenReader()) {
      next(to.path === '/login' ? undefined : '/login')
      return
    }
    if (to.path === '/login') {
      next()
      return
    }
    let destination
    try {
      const validSession = await bootstrapAccessForNavigation(store, tokenReader)
      if (!validSession) {
        destination = '/login'
      } else if (!store.getters['access/ready']) {
        destination = accessRecoveryLocation(to.fullPath || to.path)
      } else if (!store.state.permission.loaded) {
        const routes = await store.dispatch('permission/generateRoutes')
        if (!tokenReader()) {
          destination = '/login'
        } else {
          router.addRoutes(routes.concat([{ path: '*', redirect: '/404' }]))
          destination = { ...to, replace: true }
        }
      } else if (!routeCapabilityAllowed(to, store)) {
        destination = '/403'
      }
    } catch (error) {
      destination = tokenReader() ? accessRecoveryLocation(to.fullPath || to.path) : '/login'
    }
    next(destination)
  }
}



// WEBPACK FOOTER //
// ./src/router/authenticated-navigation.js